import http from "../../services/http";

const changeExperiencia = async (formulario) => {
  return await http("post", `v1/experiencias/alterar`, formulario);
};

const getExperiencia = async () => {
  return await http("get", `v1/experiencias/carregar`, []);
};

export { changeExperiencia, getExperiencia };
